import type { FichaMetric } from "./metrics";

export function MetricGrid({ metrics }: { metrics: FichaMetric[] }) {
  if (metrics.length === 0) return null;

  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
      {metrics.map((metric) => (
        <div key={metric.label}>
          <p className="text-2xl font-semibold tabular-nums text-card-foreground">
            {metric.value}
          </p>
          <p className="mt-1 text-sm text-muted-foreground">{metric.label}</p>
          <p className="text-xs text-muted-foreground">{metric.hint}</p>
        </div>
      ))}
    </div>
  );
}
